module.exports = __webpack_public_path__ + "static/media/Launch-Background.6303ae23.png";